import React, { memo } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BtnPopoverSmall from './BtnPopoverSmall';
import { Divider } from '@mui/material';

const getIcon = () => {
  return (<InfoOutlinedIcon />);
};

const InfoForArticle = () => {

  return (
    <BtnPopoverSmall title={'Article'} getIcon={getIcon} iconMedium={true}>
      <ul>
        <li>aL L...</li>
        <li>an n...</li>
        <li>an d...</li>
        <li>an t...</li>
        <li>an h...</li>
        <li>an a...</li>
        <li>an e...</li>
        <li>an i...</li>
        <li>an o...</li>
        <li>an u...</li>
        <li>ar ...</li>
      </ul>
      <Divider />
      <ul>
        <li>L -> al, ul</li>
        <li>N, D, T, H (mute), AEIOU -> an, un</li>
        <li>others -> ar, ur</li>
      </ul>
    </BtnPopoverSmall>
  );
};

export default memo(InfoForArticle);
